import { useState, useEffect, forwardRef } from "react";
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const ReportViewAutocomplete = forwardRef((props, ref) => {
    const { allOption, selectedValues = [], isFormikFormField = false, showFormError = false,
        isCompulsory = false, singleSelect = true, label = "Report View", searchPlaceholder = "Search By Report View",
        noDataLabel = "No Report View Found", width = 180, listWidth = width, optionIds = ['1', '2'],
        ...rest } = props;
    const fullReportViewOptions = [{ label: 'Summary View', id: '1' }, { label: 'Detailed View', id: '2' }, { label: 'Job Card View', id: '3' }]
    let reportViewOptions = fullReportViewOptions.filter(option =>
        optionIds.includes(option.id)
    );
    if (allOption) {
        reportViewOptions.unshift({ label: 'All', id: '-1' })
    }
    let initialProps = {
        ...rest,
        labelKey: 'label',
        primaryKey: 'id',
        options: reportViewOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        isCompulsory,
        singleSelect,
        label,
        searchPlaceholder,
        noDataLabel,
        width,
        listWidth,
        dataLoaded: selectedValues.length > 0 ? false : true
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);

    useEffect(() => {
        if (selectedValues.length > 0) {
            let preSelectedValues = [];
            if (selectedValues.length > 0) {
                preSelectedValues = reportViewOptions.filter((rv) => selectedValues.indexOf(rv.id) >= 0);
                const newProps = { ...defaultProps, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValues]);

    return (defaultProps.dataLoaded ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default ReportViewAutocomplete;